module.exports = __webpack_public_path__ + "img/1474001611.37a3729b.jpg";